import { z as zod } from 'zod';

import { CommentSchema } from '#types/schemas/comment.schema';

/**
 * Zod schema for a mailing comment, extending the base `CommentSchema` with an additional `mailingId` property.
 *
 * @see CommentSchema
 *
 * @property {number} mailingId - The unique identifier of the mailing associated with the comment.
 */
export const MailingCommentSchema = CommentSchema.extend({
  mailingId: zod.number(),
});
